// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetIntegrationCallByIdRequestModel from '../../model/get-integration-call-by-id-request-model';
import GetIntegrationCallByIdRequestDTO from '../dto/get-integration-call-by-id-request-dto';
import dtoSchema from '../schemas/get-integration-call-by-id-request-schema';

export default abstract class GetIntegrationCallByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetIntegrationCallByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetIntegrationCallByIdRequestDTO>): GetIntegrationCallByIdRequestModel;
  static toModel(dto: DeepPartial<GetIntegrationCallByIdRequestDTO> | undefined | null): GetIntegrationCallByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetIntegrationCallByIdRequestDTO> | undefined | null): GetIntegrationCallByIdRequestModel | undefined {
    return dto ? new GetIntegrationCallByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetIntegrationCallByIdRequestModel> | GetIntegrationCallByIdRequestModel): GetIntegrationCallByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetIntegrationCallByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetIntegrationCallByIdRequestModel, can not map to GetIntegrationCallByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
